<template>
  <div class="marketplace-app">
    <a-page-header :title="app ? app.name : 'Yükleniyor...'" @back="() => $router.push('/marketplace')" />
    <a-row :gutter="[16, 16]" v-if="app">
      <a-col :md="24">
        <a-card>
          <div class="app-flex-container">
            <div class="app-logo">
              <img v-if="app.icon" :src="app.icon" :alt="app.name">
              <AppstoreOutlined v-else style="font-size: 64px; color: #1890ff" />
            </div>
            <div class="app-details">
              <div class="app-title">{{ app.name }}</div>
              <div class="app-desc">{{ app.dsc }}</div>
              <div class="app-meta">
                <span v-if="app.category_name">{{ app.category_name }}</span>
                <template v-if="app.product_version">
                  <span class="divider">|</span>
                  <span>Version {{ app.product_version }}</span>
                </template>
                <template v-if="app.product_os">
                  <span class="divider">|</span>
                  <span>OS · {{ app.product_os }}</span>
                </template>
              </div>
              <div v-if="!app.is_active" class="app-submeta">
                Otomatik Kurulum
                <a-tag color="blue">YAKINDA</a-tag>
              </div>
            </div>
            <div class="app-action">
              <template v-if="app.is_active">
                <a-button type="primary" size="large" @click="$router.push(`/marketplace/deploy/${app.slug}`)">Sanal Makineyi Oluştur</a-button>
              </template>
              <template v-else>
                <a href="mailto:info@example.com">
                  <a-button type="primary" size="large">
                    <template #icon><MailOutlined /></template>
                    İletişime Geç
                  </a-button>
                </a>
              </template>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-row v-if="app" style="margin-top: 16px">
      <a-col :md="24">
        <a-card>
          <a-tabs v-model:activeKey="activeTab">
            <a-tab-pane key="presentation" tab="Genel Bakış">
              <div v-if="app.product_overview" class="ql-content" v-html="app.product_overview"></div>
              <p v-else>Detaylı bilgi için lütfen iletişime geçin.</p>
            </a-tab-pane>
            <a-tab-pane key="pricing" tab="Fiyatlandırma">
              <div v-if="app.product_prices" class="ql-content" v-html="app.product_prices"></div>
              <p v-else>Detaylı fiyat bilgisi için lütfen iletişime geçin.</p>
            </a-tab-pane>
            <a-tab-pane key="support" tab="Destek">
              <div v-if="app.product_support" class="ql-content" v-html="app.product_support"></div>
              <p v-else>Destek için lütfen iletişime geçin.</p>
            </a-tab-pane>
          </a-tabs>
        </a-card>
      </a-col>
    </a-row>
    <a-spin v-if="loading" style="margin-top: 40px; display: block; text-align: center" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { AppstoreOutlined, MailOutlined } from '@ant-design/icons-vue'

export default {
  name: 'MarketPlaceApp',
  components: {
    AppstoreOutlined,
    MailOutlined
  },
  setup () {
    const route = useRoute()
    const app = ref(null)
    const loading = ref(false)
    const activeTab = ref('presentation')

    const fetchData = async () => {
      loading.value = true
      try {
        const slug = route.params.slug
        const res = await axios.get(`https://cs-portal.bulutpark.tr/api/marketplace/products/${slug}`)
        app.value = res.data
      } catch (error) {
        console.error('Error fetching app:', error)
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchData)

    return { app, loading, activeTab, fetchData }
  }
}
</script>

<style scoped>
.app-flex-container {
  display: flex;
  align-items: center;
  gap: 40px;
}
.app-logo img {
  width: 120px;
  height: auto;
}
.app-details {
  flex: 1;
  min-width: 0;
}
.app-title {
  font-size: 24px;
  font-weight: 700;
  color: #23272f;
  margin-bottom: 16px;
}
.app-desc {
  color: #555;
  font-size: 14px;
  margin-bottom: 10px;
  max-width: 900px;
}
.app-meta {
  color: #555;
  font-size: 14px;
  margin-bottom: 8px;
}
.app-meta .divider {
  margin: 0 16px;
  color: #e5e7eb;
}
.app-submeta {
  font-size: 14px;
  margin-bottom: 0;
}
.app-action {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
</style>

<style>
.ql-content h1 { font-size: 2em; font-weight: bold; margin: 0.67em 0; }
.ql-content h2 { font-size: 1.5em; font-weight: bold; margin: 0.83em 0; }
.ql-content h3 { font-size: 1.17em; font-weight: bold; margin: 1em 0; }
.ql-content p { margin: 0 0 1em 0; }
.ql-content ul, .ql-content ol { padding-left: 1.5em; margin: 0 0 1em 0; }
.ql-content li { margin-bottom: 0.25em; }
.ql-content strong { font-weight: bold; }
.ql-content em { font-style: italic; }
.ql-content a { color: #1890ff; text-decoration: underline; }
.ql-content blockquote {
  border-left: 4px solid #ccc;
  margin: 0 0 1em 0;
  padding: 0.5em 1em;
  color: #666;
}
.ql-content img { max-width: 100%; height: auto; }
.ql-content pre {
  background: #f5f5f5;
  padding: 1em;
  border-radius: 4px;
  overflow-x: auto;
}
.ql-content code {
  background: #f0f0f0;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: monospace;
}
</style>
